import React from 'react';
import { RichTextWithGlossaries } from './RichTextStepWithGlossaries';
import { Glossary } from '@/services/apis/glossaries';
import { GuideLanguage } from '@/services/apis/guides';

interface RichTextStepProps {
  content?: {
    text?: string;
  };
  title?: string;
  glossaries: Glossary[];
  currentLanguage?: GuideLanguage;
}

const RichTextStep: React.FC<RichTextStepProps> = ({ content, glossaries, currentLanguage }) => {
  const text = content?.text || '';

  return (
    <div className="rich-text-content slide-content text-foreground">
      <RichTextWithGlossaries htmlContent={text} glossaries={glossaries} currentLanguage={currentLanguage} />
    </div>
  );
};

export default RichTextStep;
